"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEcEventData = exports.getBannerType = void 0;
var cookie_1 = require("./cookie");
var allowedTakeoverTags = ['board_2'];
var horseShoeDivs = ['skyscraperleft_1', 'topboard', 'skyscraperright_1'];
function isHorseshoeElement(tagName, hasHorseshoe) {
    return hasHorseshoe && horseShoeDivs.includes(tagName);
}
function isTakeover(tagName, adObj) {
    var isAllowedTag = allowedTakeoverTags.includes(tagName);
    return (isAllowedTag &&
        adObj.height &&
        adObj.width &&
        adObj.height === 3 &&
        adObj.width === 3);
}
function getNativeType(adObj) {
    if (adObj.native) {
        if (adObj.targetId === 'contentboard') {
            return 'contentboard';
        }
        if (adObj.native.desc2) {
            return adObj.native.desc2;
        }
        if (adObj.native.custom) {
            return adObj.native.custom.type;
        }
    }
    return '';
}
function getNativeBannerType(adObj) {
    var nativeType = getNativeType(adObj);
    var nativeTypeName = nativeType ? nativeType : 'netboard';
    return "native-" + nativeTypeName;
}
function getBannerType(tagName, adObj, hasHorseshoe) {
    if (adObj) {
        switch (adObj.source) {
            case 'rtb':
                switch (adObj.adType) {
                    case 'banner':
                        if (isTakeover(tagName, adObj)) {
                            return 'banner-takeover';
                        }
                        else if (isHorseshoeElement(tagName, hasHorseshoe)) {
                            return 'banner-horseshoe';
                        }
                        return 'banner';
                    case 'video':
                        return 'video';
                    case 'native':
                        return getNativeBannerType(adObj);
                    default:
                        return 'banner';
                }
            case 'csm':
                return 'banner';
        }
    }
    return 'banner';
}
exports.getBannerType = getBannerType;
function getEcEventData(tagId, ele, vertical, creativeId, adObj, hasHorseshoe) {
    var url = document.baseURI;
    var listPos = '';
    var finnkode = '';
    var creativeType = getBannerType(tagId, adObj, hasHorseshoe);
    if (ele && url && url.includes('/search.html')) {
        listPos = Number(ele.getAttribute('data-position-index'));
    }
    else if (url && url.includes('/ad.html')) {
        finnkode = Number(new URL(url).searchParams.get('finnkode'));
    }
    var eventData = {
        'extra.position': tagId,
        'extra.vertical': vertical,
        'extra.session': cookie_1.getSession(),
        'extra.creativeId': creativeId ? creativeId.toString() : '',
        'extra.creativeType': creativeType,
        'extra.pageurl': window.location.href,
        'extra.listPos': listPos.toString(),
        'extra.abtest': cookie_1.getAbTestCookie(),
        finnkode: finnkode.toString(),
    };
    return eventData;
}
exports.getEcEventData = getEcEventData;
